import React from 'react';
import { autorun } from 'mobx';
import { ScreenStore } from '../../stores/ScreenStore';
import { RoutingStore } from '../../stores/RoutingStore';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { getLogger } from '../../utils/fedops-logger';
import { injectStoresV1 } from '../../stores/injectStoresV1';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import s from './Preview.scss';

export interface PreviewProps extends WithTranslations {
  dataHook?: string;
  screenStore: ScreenStore;
  routingStore: RoutingStore;
  templatesStore: TemplatesStore;
}

export class PreviewComp extends React.Component<PreviewProps> {
  constructor(props) {
    super(props);
    autorun(() => {
      !this.props.screenStore.isSinglePage && this.props.screenStore.setIframeLoaded(false);
      PreviewComp.endPreviewInteraction(this.props);
    });
  }
  private handlePreviewLoad = (e): void => {
    this.props.screenStore.setIframeLoaded(!!e.target.src);
  };

  private static endPreviewInteraction(props): void {
    props.screenStore.screen === 'preview' &&
      props.screenStore.isIframeLoaded &&
      getLogger().interactionEnded('mobile-preview');
  }

  private handleBackClick = (e): void => {
    e.preventDefault();
    history.go(-2);
  };

  public render() {
    const title = `Preview of website ${this.props.templatesStore.expandedTemplate?.title}`;
    const previewSrc = this.props.screenStore.previewIframeUrl;

    return (
      <div data-hook={this.props.dataHook} className={s.preview}>
        <div className={s.frameScaler}>
          <iframe
            title={title}
            onLoad={this.handlePreviewLoad}
            className={s.frame}
            data-hook="previewFrame"
            src={previewSrc}
            key={this.props.templatesStore.expandedTemplate?.id}
          />
        </div>
        <div className={s.backLinkWrapper}>
          <span role="link" className={s.backLink} data-hook="backLink" onClick={this.handleBackClick}>
            {this.props.t('template.preview.back')}
          </span>
        </div>
      </div>
    );
  }
}

export const Preview = withTranslations(
  injectStoresV1('screenStore', 'routingStore', 'templatesStore')(PreviewComp as React.ComponentClass<PreviewProps>),
);
